import { render, staticRenderFns } from "./TerminalDeltaSyncDetailsTable.vue?vue&type=template&id=3f072ba8&"
import script from "./TerminalDeltaSyncDetailsTable.vue?vue&type=script&lang=js&"
export * from "./TerminalDeltaSyncDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./TerminalDeltaSyncDetailsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports